import {
  MembershipActionTypes,
  UpdateMembershipSuccess,
} from '@features/transfer-connect-v2/store/actions/membership.actions';
import { PointsTransferMembership } from '@rd/types';
import { RewardsPreference } from '../../types/rewards-preference.type';
import {
  RewardsPreferenceActions,
  RewardsPreferenceActionTypes,
} from '../actions/rewards-preference.actions';

export interface RewardsPreferenceState {
  rewardsPreference: RewardsPreference | null;
  getRewardsPreference: {
    loading: boolean;
    success: boolean;
    error: boolean;
  };
  createRewardsPreference: {
    loading: boolean;
    success: boolean;
    error: boolean;
  };
}

const initialState: RewardsPreferenceState = {
  rewardsPreference: null,
  getRewardsPreference: {
    loading: false,
    success: false,
    error: false,
  },
  createRewardsPreference: {
    loading: false,
    success: false,
    error: false,
  },
};

export function rewardsPreferenceReducer(
  state: RewardsPreferenceState = initialState,
  action: RewardsPreferenceActions | UpdateMembershipSuccess,
): RewardsPreferenceState {
  switch (action.type) {
    case RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE: {
      return {
        ...state,
        getRewardsPreference: {
          loading: true,
          success: false,
          error: false,
        },
      };
    }
    case RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE_SUCCESS: {
      return {
        ...state,
        rewardsPreference: action.payload,
        getRewardsPreference: {
          success: true,
          loading: false,
          error: false,
        },
      };
    }
    case RewardsPreferenceActionTypes.LOAD_REWARDS_PREFERENCE_FAIL: {
      return {
        ...state,
        getRewardsPreference: {
          success: false,
          loading: false,
          error: true,
        },
      };
    }
    case RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE: {
      return {
        ...state,
        createRewardsPreference: {
          loading: true,
          success: false,
          error: false,
        },
      };
    }
    case RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE_SUCCESS: {
      return {
        ...state,
        rewardsPreference: action.payload,
        createRewardsPreference: {
          success: true,
          loading: false,
          error: false,
        },
      };
    }
    case RewardsPreferenceActionTypes.CREATE_REWARDS_PREFERENCE_FAIL: {
      return {
        ...state,
        createRewardsPreference: {
          success: false,
          loading: false,
          error: true,
        },
      };
    }
    case MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS: {
      if (
        action.payload.membership.loyaltyProgramId ===
        state.rewardsPreference?.membership.loyaltyProgramId
      ) {
        return {
          ...state,
          rewardsPreference: {
            ...state.rewardsPreference,
            membership: action.payload.membership as PointsTransferMembership,
          },
        };
      }

      return state;
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
